import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../config';
import loadingIcon from '../images/loading.svg';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../constants/locales';

export default function DeliveryPriceForm() {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [country, setCountry] = useState(LOCALES[0].country);
    const [price, setPrice] = useState('');
    const [loading, setLoading] = useState(!!id);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!id) return;
        axios.get(`${config.API_URL}/api/deliveryPrice/getAll`)
            .then(response => {
                const existing = response.data.find(item => item.id === id);
                if (existing) {
                    setCountry(existing.country);
                    setPrice(existing.price);
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [id]);

    async function sendForm(e) {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const authHeader = { 'Authorization': `Bearer ${localStorage.getItem("access_tocken")}` };

        try {
            if (id) {
                await axios.put(`${config.API_URL}/api/deliveryPrice/update/${id}`, null, {
                    params: { country, price },
                    headers: authHeader
                });
            } else {
                await axios.post(`${config.API_URL}/api/deliveryPrice/create`, { country, price }, {
                    headers: { 'Content-Type': 'application/json', ...authHeader }
                });
            }
            navigate('/admin');
        } catch (error) {
            setError(error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <div className='loading'><img src={loadingIcon} alt='none gif' /></div>;
    }

    return (
        <div className='updateProduct'>
            {error && <p className='updateProduct-error'>{typeof error === 'string' ? error : JSON.stringify(error)}</p>}
            <form onSubmit={sendForm}>
                <div className='updateProduct-main'>
                    <div className='updateProduct-fields'>
                        <label>{t('cart.country')}</label>
                        <select value={country} onChange={(e) => setCountry(e.target.value)}>
                            {LOCALES.map(locale => (
                                <option key={locale.country} value={locale.country}>{locale.label} ({locale.country})</option>
                            ))}
                        </select>
                        <label>{t('admin.deliveryPrice', 'Delivery price')}</label>
                        <input type="number" step="0.01" value={price} onChange={(e) => setPrice(e.target.value)} />
                    </div>
                </div>
                <button type='submit'>{t('updateForm.apply')}</button>
            </form>
        </div>
    );
}
